import { Routes, Route } from "react-router-dom";
import { Login, NotFoundPage, LandingPage, InboxPage, CentresPage, ChildMatchPage, ExportPage, WinzRatesPage } from "../pages";
import { ToastContainer } from "react-toastify";
import { AuthenticationServiceProvider } from "../services/authentication.service";
import { LandingServiceProvider } from "../pages/landing/contexts/landing.service.context";
import { MasterLayout } from ".";
import { PrivateRoute } from "../components";
import roles from "../utils/constants/roles";
import { ExportServiceProvider } from "../pages/export/ExportServiceContext";

export default function ProviderLayout() {
  return (
    <AuthenticationServiceProvider>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route
          path="/"
          element={
            <PrivateRoute roles={roles.ALL_ROLES}>
              <MasterLayout />
            </PrivateRoute>
          }
        >
          <Route
            path="/"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <LandingServiceProvider>
                  <LandingPage />
                </LandingServiceProvider>
              </PrivateRoute>
            }
          />           
          <Route
            path="/inbox"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <InboxPage />
              </PrivateRoute>
            }
          />         
          <Route
            path="/centres"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <CentresPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/centres/:centreId"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <ChildMatchPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/export"
            element={
              <PrivateRoute roles={roles.ADMINS}>
                <ExportServiceProvider>
                  <ExportPage />
                </ExportServiceProvider>
              </PrivateRoute>
            }
          />
          <Route
            path="/winzrates"
            element={
              <PrivateRoute roles={roles.ADMINS}>
                <WinzRatesPage />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthenticationServiceProvider>
  );
}
